import { useMemo } from 'react';
import { Text as RNText, StyleSheet } from 'react-native';
import { ThemedFonts } from 'styles/themed';
import { colorList } from 'utils/colors';

const categories = StyleSheet.create({
    default: { fontSize: 15, color: '#000' },
    h1: { fontSize: 28, fontWeight: 'bold' },
    h2: { fontSize: 22, fontWeight: 'bold' },
    h3: { fontSize: 18, fontWeight: 'bold' },
    h4: { fontSize: 16, fontWeight: 'bold' },
    s1: { fontSize: 15, fontWeight: 'normal' },
    s2: { fontSize: 13, fontWeight: '400' },
    c1: { fontSize: 14, fontWeight: 'normal' },
    c2: { fontSize: 13, fontWeight: '400' },
    label: { fontSize: 14, color: '#a1a1a1' },
});

const appearances = StyleSheet.create({
    hint: { color: colorList.TEXT_HINT.primary },
    primary: { color: colorList.PRIMARY.primary },
});

const alignments = StyleSheet.create({
    left: { textAlign: 'left' },
    center: { textAlign: 'center' },
    right: { textAlign: 'right' },
});

const fontsByWeight = {
    bold: ThemedFonts.bold,
    700: ThemedFonts.bold,
    600: ThemedFonts.semiBold,
    500: ThemedFonts.semiBold,
    400: ThemedFonts.semiBold,
};

const Text = ({ children, category, appearance, style, textAlign, ...textProps }) => {

    const textStyle = useMemo( () => {
        const categoryStyle = Object.hasOwn( categories, category ) ? categories[ category ] : categories.default;
        const appearanceStyle = Object.hasOwn( appearances, appearance ) ? appearances[ appearance ] : undefined;
        const alignmentStyle = Object.hasOwn( alignments, textAlign ) ? alignments[ textAlign ] : undefined;
        const { fontWeight, ...resolvedStyle } = StyleSheet.flatten([ categoryStyle, appearanceStyle, style ]);
        const fontStyle = Object.hasOwn( fontsByWeight, fontWeight ) ? fontsByWeight[ fontWeight ] : ThemedFonts.regular;

        // Choose the bundled font instead of asking native Text to synthesize a
        // weight. Preserve caller colors and the explicit alignment override.
        return { 
            ...resolvedStyle, 
            ...fontStyle, 
            ...alignmentStyle 
        };
    }, [ category, appearance, style, textAlign ] );

    return (
        <RNText { ...textProps } style={ textStyle }>
            { children }
        </RNText>
    );
};

export default Text;
